import { render, staticRenderFns } from "./MemberVotingDashboard.vue?vue&type=template&id=06ac03c5&scoped=true"
import script from "./MemberVotingDashboard.vue?vue&type=script&lang=js"
export * from "./MemberVotingDashboard.vue?vue&type=script&lang=js"
import style0 from "./MemberVotingDashboard.vue?vue&type=style&index=0&id=06ac03c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac03c5",
  null
  
)

export default component.exports